import React, { Component } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, IconButton } from "@mui/material";
import { FormControl } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import MoreOptions from "../priceListOption";
import settings from "../../helpers/Settings";
import Row from "react-bootstrap/Row";
import Cookies from "js-cookie";
import Col from "react-bootstrap/Col";
import axios from "axios";
import * as XLSX from "xlsx";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Accordion from "react-bootstrap/Accordion";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
};
const allInsuraceCompanies = {
  "INS-FHIR": "Pseudo Payer",
  7001571327: "Bupa Arabia for Cooperative Insurance",
  7000911508: "The Cooperative Company for Cooperative Insurance",
  7001593321: "Al-Rajhi Company for Cooperative Insurance",
  7001548317:
    "The Mediterranean and Gulf Cooperative Insurance and Reinsurance Company (MedGulf)",
  7001539720: "Saudi Arabian Cooperative Insurance Company (SAICO) *",
  7001532279: "Gulf Union Cooperative Insurance Company",
  7001607683: "AXA Cooperative Insurance Company",
  7001519912: "Malath Cooperative Insurance and Reinsurance Company",
  7001559389: "United Cooperative Insurance Company",
  7001727200: "Tokyo Marine Development Corporation",
  7001527816: "Arabian Shield Cooperative Insurance Company *",
  7001617724: "Buruj Cooperative Insurance Company *",
  7001549059: "Trade Union Cooperative Insurance Company *",
  7001544472: "Al Sagr Cooperative Insurance Company *",
  7001641419: "Gulf General Company for Cooperative Insurance",
  7001609481: "Global Company for Cooperative Insurance",
  7001535694: "Allied Cooperative Insurance Group (ACIG)",
  7001526578: "Saudi United Cooperative Insurance Company (Wala",
  7001537161: "Allianz Saudi Fransi Cooperative Insurance Company",
  7001534275: "The National Company for Cooperative Insurance",
  7001626717: "Amana Cooperative Insurance Company *",
  7001625891: "Solidarity Saudi Takaful Company",
  7001703672: "Saudi Enaya Cooperative Insurance Company",
  7001523724: "Salama Cooperative Insurance Company",
  7001527667: "Arabia Insurance Cooperative Company",
};
class priceListManagment extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      searchInfo: {},
      searchLoading: false,
      selectedFile:"",
      extentionFile:false
    };
  }
  componentDidMount = async () => {
    // this.getPriceList();
  };
  onFileChange = (e) => {
    const allowedExtensions = ["xlsx"];
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.setState({
        extentionFile: true,
      });
    } else
      this.setState({ selectedFile: e.target.files[0], fileMsg: "",extentionFile:false });

  };
  handleFileUpload = (e) => {
    if (!this.state.selectedFile&&!this.state.extentionFile) {
      this.setState({
        fileMsg:"Make sure to select a file to upload"
      });
    }else if(!this.state.selectedFile&&this.state.extentionFile){
      this.setState({
        fileMsg: "It seems you've tried to upload a file with an unsupported extension. Currently, we only accept the following file types: .xlsx",
      });
    }
    else {
      this.setState({ fileMsg: "",extentionFile:false ,uploadLoading:true })
      const reader = new FileReader();
      reader.readAsBinaryString(this.state.selectedFile);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet);
        let arr = [];
        for (let i = 0; i < parsedData.length; i++) {
          arr.push({
            providerid: parsedData[i]["Provider ID"]
              ? parsedData[i]["Provider ID"]
              : "",
            payerid: parsedData[i]["Payer ID"] ? parsedData[i]["Payer ID"] : "",
            payername: parsedData[i]["Payer Name"] ? parsedData[i]["Payer Name"] : "",
            internalcode: parsedData[i]["Internal Code"]
              ? parsedData[i]["Internal Code"]
              : "",
            internaldescription: parsedData[i]["Internal Description"]
              ? parsedData[i]["Internal Description"]
              : "",
            price: parsedData[i]["Price"] ? parsedData[i]["Price"] : 0,
            discount: parsedData[i]["Discount"] ? parsedData[i]["Discount"] : 0,
            packagee: parsedData[i]["Package"],
            sbscode: parsedData[i]["SBS Code"] ? parsedData[i]["SBS Code"] : "",
            sbsdescription: parsedData[i]["SBS Description"]
              ? parsedData[i]["SBS Description"]
              : "",
            servicetype: parsedData[i]["Service Type"] ? parsedData[i]["Service Type"] : "",
          });
        }
        this.sendReq(arr, e);
        // }

      };

    }
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
    this.setState({ selectedFile: "" })
  };
  sendReq = async (parsedData, e) => {
    console.log(parsedData, "ppppppppppppppp");
    let Response = await axios.post(
      KayanURL + "api/KSA/RCM/priceList/addNewPriceList",
      {
        data: parsedData,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      if (data) {
        setTimeout(() => {
          this.setState({ uploadLoading: false });
        }, 1000);
        console.log('data:', data)
        if (data.success) {
          this.setState({ success: true, uploadModal: false ,searchMsg:""});
          // this.getPriceList();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };
  handleCheckBoxChange = (e) => {
    if (e.target.checked) {
      this.setState({ packagee: true });
    } else {
      this.setState({ packagee: false });
    }

  };
 
  deletePriceList = async (id) => {
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/pricelist/deletePriceList",
      {
        id: id,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        payerId: this.state.payerId
      }
    );

    if (response) {
      let { data } = response;
      if (data.success) {
        // this.getPriceList();
        let { pricelist } = data;
        this.setState({ priceList: pricelist });
      } else {
        let { error } = data;
        if (error) {
          this.setState({ error: error });
        }
      }
    }
  };
  closeUploadModal = () => {
    this.setState({
      uploadModal: false,
      selectedFile: "",
      fileMsg: ""
    });
  };
  updatePriceList = async (id) => {
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/pricelist/updatePriceList",
      {
        data: {
          id: this.state.id,
          internalcode: this.state.internalcode,
          internaldescription: this.state.internaldescription,
          price: this.state.price,
          discount: this.state.discount,
          packagee: this.state.packagee,
          sbscode: this.state.sbscode,
          sbsdescription: this.state.sbsdescription,
          servicetype: this.state.servicetype
        },
        payerId: this.state.payerId,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );

    if (response) {
      let { data } = response;
      if (data.success) {
        // this.getPriceList();
        let { pricelist } = data;
        this.setState({ priceList: pricelist, updatePriceListModal: false });
      } else {
        let { error } = data;
        if (error) {
          this.setState({ error: error });
        }
      }
    }
  };

  getPriceList = async (searchInfo) => {
    let priceList = await axios.put(
      KayanURL + "api/KSA/RCM/priceList/getPriceList",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        payerid: searchInfo.payerid,
      }
    );
    if (priceList) {
      let { data } = priceList;
      if (data) {
        setTimeout(() => {
          this.setState({ searchLoading: false });
        }, 1000);
        if (data.success) {
          let { pricelist } = data;
          console.log(pricelist,"data")
          if (priceList && pricelist.length > 0)
            this.setState({ searchMsg: "" })
          else
            this.setState({ searchMsg: "The price list for the selected insurance didn't uploaded yet, make sure to upload it." })
          this.setState({ priceList: pricelist });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      searchInfo: { ...this.state.searchInfo, [name]: value },
      [name]: value,
      payerId: value
    });

  };
  handleSearchRequest = async () => {
    let { searchInfo } = this.state;
    if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
      this.setState({ searchErrMsg: "Please select a value to search", searchMsg: "" });
    }
    for (let key in searchInfo) {
      if (searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
        this.setState({ searchErrMsg: "Please select a value to search", searchMsg: "" });
      } else {
        this.setState({
          searchErrMsg: "",
          searchLoading: true
        });
        this.getPriceList(searchInfo)
      }
    }
    this.setState({
      searchInfo: {},
      payerid: "",
    });
  };
  // getMedicationList = async () => {
  //   let response = await axios.put(
  //     KayanURL + "api/KSA/RCM/priceList/getAllMedication",
  //     {
  //       apiToken: Cookies.get("RCM_KSA_Employee_Token"),
  //     }
  //   );
  //   if (response) {
  //     let { data } = response;
  //     if (data) {
  //       if (data.success) {
  //         let { medicationList } = data;
  //         this.setState({ medicationList: medicationList,priceList:[] });
  //       } else {
  //         this.setState({ error: data.error });
  //       }
  //     }
  //   }
  // };
  handleClosePriceListModal = () => {
    this.setState({ updatePriceListModal: false });
  };
  handleUpdatePriceList = async (index) => {
    this.setState({
      updatePriceListModal: true,
    });
    let { priceList } = this.state;
    let selectedPriceList = priceList.filter((p) => {
      return p.id == index;
    });
    if (selectedPriceList && selectedPriceList.length > 0) {
      selectedPriceList = selectedPriceList[0];
      console.log(selectedPriceList, 'selected')
      this.setState({
        id: selectedPriceList["id"],
        internalcode: selectedPriceList["internalcode"],
        internaldescription: selectedPriceList["internaldescription"],
        price: selectedPriceList["price"],
        discount: selectedPriceList["discount"],
        packagee: selectedPriceList["package"],
        sbscode: selectedPriceList["sbscode"],
        sbsdescription: selectedPriceList["sbsdescription"],
        servicetype: selectedPriceList["servicetype"],
      });
    }
  };
  handleTextChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    let { priceList} = this.state;
    let priceListRows = [];
    if (priceList && priceList.length > 0) {
      priceListRows = priceList.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.payername || element.payername !== undefined?element.payername:"" }{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.payerid}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.providerid}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.servicetype || element.servicetype !== undefined?element.servicetype:"" }{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.internalcode}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.internaldescription}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.price}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.discount}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.package ? "TRUE" : "FALSE"}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.sbscode}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.sbsdescription}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              <div>
                <a style={{cursor:"pointer",marginRight:"5px"}} onClick={()=>this.handleUpdatePriceList(element.id)}>
                  <EditIcon style={{ fontSize: "17px" }} />

                </a>
                <a style={{cursor:"pointer"}} onClick={()=>this.deletePriceList(element.id)}>
                  <DeleteIcon style={{ fontSize: "17px" }} />

                </a>

              </div>


            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <div>
        <div
          style={{
            textAlign: "center",
            margin: "auto",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px",
            marginTop: "50px",
            width: "95%",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Button
              variant="contained"
              style={{
                backgroundColor: "rgb(97 110 120",
                border: "1px ridge gray",
                width: "25%",
                boxShadow: "none",
                height: "35px",
                color: "white",
                fontSize: "small",
                marginTop: "20px",
                marginRight: "10px",
                transition: "background-color 0.4s, color 0.4s",

              }}
              onClick={() => this.setState({ uploadModal: true })}
            >
              {this.state.uploadLoading
                      ? "Loading..."
                      : "Upload File"}
            </Button>
            
          </div>

         
          <Accordion
            defaultActiveKey="0"
            style={{
              margin: "30px auto",
              paddingBottom: "20px",
              width: "50%",
            }}
          >
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <span style={{ color: "grey" }}>Search Price List</span>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col>
                    <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                      <InputLabel
                        id="insurance"
                        style={{ fontSize: "small" }}
                      >
                        Insurance Company
                      </InputLabel>
                      <Select
                        required
                        labelId="insurance"
                        name="payerid"
                        label="Insurance Company"
                        value={this.state.payerid ? this.state.payerid : ""}
                        onChange={this.HandleInputSearchRequestTextChange}
                        style={{ height: "45px" }}
                      >
                        <MenuItem
                          value="INS-FHIR"
                          name="Pseudo Payer"
                          style={{ fontSize: "small" }}
                        >
                          Pseudo Payer
                        </MenuItem>
                        <MenuItem
                          value="7001571327"
                          style={{ fontSize: "small" }}
                        >
                          Bupa Arabia for Cooperative Insurance
                        </MenuItem>
                        <MenuItem
                          value="7000911508"
                          style={{ fontSize: "small" }}
                        >
                          The Cooperative Company for Cooperative Insurance
                        </MenuItem>
                        <MenuItem
                          value="7001593321"
                          style={{ fontSize: "small" }}
                        >
                          Al-Rajhi Company for Cooperative Insurance
                        </MenuItem>
                        <MenuItem
                          value="7001548317"
                          style={{ fontSize: "small" }}
                        >
                          The Mediterranean and Gulf Cooperative Insurance
                          and Reinsurance Company (MedGulf)
                        </MenuItem>
                        <MenuItem
                          value="7001539720"
                          style={{ fontSize: "small" }}
                        >
                          Saudi Arabian Cooperative Insurance Company
                          (SAICO) *
                        </MenuItem>
                        <MenuItem
                          value="7001532279"
                          style={{ fontSize: "small" }}
                        >
                          Gulf Union Cooperative Insurance Company
                        </MenuItem>
                        <MenuItem
                          value="7001607683"
                          style={{ fontSize: "small" }}
                        >
                          AXA Cooperative Insurance Company
                        </MenuItem>
                        <MenuItem
                          value="7001519912"
                          style={{ fontSize: "small" }}
                        >
                          Malath Cooperative Insurance and Reinsurance
                          Company
                        </MenuItem>
                        <MenuItem
                          value="7001527667"
                          style={{ fontSize: "small" }}
                        >
                          Arabia Insurance Cooperative Company
                        </MenuItem>
                        <MenuItem
                          value="7001523724"
                          style={{ fontSize: "small" }}
                        >
                          Salama Cooperative Insurance Company
                        </MenuItem>
                        <MenuItem
                          value="7001703672"
                          style={{ fontSize: "small" }}
                        >
                          Saudi Enaya Cooperative Insurance Company
                        </MenuItem>
                        <MenuItem
                          value="7001625891"
                          style={{ fontSize: "small" }}
                        >
                          Solidarity Saudi Takaful Company
                        </MenuItem>
                        <MenuItem
                          value="7001626717"
                          style={{ fontSize: "small" }}
                        >
                          Amana Cooperative Insurance Company *
                        </MenuItem>
                        <MenuItem
                          value="7001534275"
                          style={{ fontSize: "small" }}
                        >
                          The National Company for Cooperative Insurance
                        </MenuItem>
                        <MenuItem
                          value="7001537161"
                          style={{ fontSize: "small" }}
                        >
                          Allianz Saudi Fransi Cooperative Insurance Company
                        </MenuItem>
                        <MenuItem
                          value="7001526578"
                          style={{ fontSize: "small" }}
                        >
                          Saudi United Cooperative Insurance Company (Wala)
                        </MenuItem>
                        <MenuItem
                          value="7001535694"
                          style={{ fontSize: "small" }}
                        >
                          Allied Cooperative Insurance Group (ACIG)
                        </MenuItem>
                        <MenuItem
                          value="7001609481"
                          style={{ fontSize: "small" }}
                        >
                          Global Company for Cooperative Insurance
                        </MenuItem>
                        <MenuItem
                          value="7001641419"
                          style={{ fontSize: "small" }}
                        >
                          Gulf General Company for Cooperative Insurance
                        </MenuItem>
                        <MenuItem
                          value="7001544472"
                          style={{ fontSize: "small" }}
                        >
                          Al Sagr Cooperative Insurance Company *
                        </MenuItem>
                        <MenuItem
                          value="7001549059"
                          style={{ fontSize: "small" }}
                        >
                          Trade Union Cooperative Insurance Company *
                        </MenuItem>
                        <MenuItem
                          value="7001617724"
                          style={{ fontSize: "small" }}
                        >
                          Buruj Cooperative Insurance Company *
                        </MenuItem>
                        <MenuItem
                          value="7001527816"
                          style={{ fontSize: "small" }}
                        >
                          Arabian Shield Cooperative Insurance Company *
                        </MenuItem>
                        <MenuItem
                          value="7001559389"
                          style={{ fontSize: "small" }}
                        >
                          United Cooperative Insurance Company
                        </MenuItem>
                        <MenuItem
                          value="7001727200"
                          style={{ fontSize: "small" }}
                        >
                          Tokyo Marine Development Corporation
                        </MenuItem>
                      </Select>
                    </FormControl>

                    <div style={{ width: "100%" }}>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          marginRight: "10px",
                          transition: "background-color 0.4s, color 0.4s"
                        }}
                        onClick={(e) => this.handleSearchRequest(e)}
                      >
                        {this.state.searchLoading ? 'Loading...' : 'Search'}

                      </Button>

                    </div>
                  </Col>
                  {this.state.searchErrMsg ? (
                    <>
                      <Typography style={{ textAlign: "center", color: "red" }}>
                        {this.state.searchErrMsg}
                      </Typography>
                    </>
                  ) : null}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          {priceList && priceList.length > 0 ? (
            <div style={{ width: "96%",margin:"auto" }}>
              <TableContainer component={Paper} style={{ marginTop: "20px", overflowX: "scroll" }}>
                <Table sx={{ minWidth: 100 }} aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                    <TableRow style={{ textAlign: "center" }}>
                      <TableCell align="center">Payer Name</TableCell>
                      <TableCell align="center">Payer ID</TableCell>
                      <TableCell align="center">Provider ID</TableCell>
                      <TableCell align="center">Service Type</TableCell>
                      <TableCell align="center">Internal Code</TableCell>
                      <TableCell align="center">Internal Description</TableCell>
                      <TableCell align="center">Price</TableCell>
                      <TableCell align="center">Discount</TableCell>
                      <TableCell align="center">Package</TableCell>
                      <TableCell align="center">SBS</TableCell>
                      <TableCell align="center">SBS Description</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{priceListRows}</TableBody>
                </Table>
              </TableContainer>
            </div>
          )
            // : medicationList && medicationList.length>0 ?(
            //   <>
            //   <Typography
            //       id="modal-modal-title"
            //       variant="h6"
            //       component="h2"
            //       style={{ textAlign: "center", marginTop: "5px" }}
            //     >
            //       Medication List
            //     </Typography>
            //     <TableContainer component={Paper} style={{ marginTop: "20px" }}>
            //       <Table sx={{ minWidth: 100 }} aria-label="simple table">
            //         <TableHead style={{ backgroundColor: "#fafafa" }}>
            //           <TableRow style={{ textAlign: "center" }}>
            //             <TableCell align="center">Provider ID</TableCell>
            //             <TableCell align="center">Provider Name</TableCell>
            //             <TableCell align="center">Gtin Code</TableCell>
            //             <TableCell align="center">Description</TableCell>
            //             <TableCell align="center">Price</TableCell>
            //           </TableRow>
            //         </TableHead>
            //         <TableBody>{medicationListRows}</TableBody>
            //       </Table>
            //     </TableContainer>
            //   </>
            // )
            :
            this.state.searchMsg ? (<>
              <h5
                style={{textAlign:"center",fontSize:"15px",marginTop:"20px",color:"red"}}
              >
                {this.state.searchMsg}
              </h5>
            </>) : null
          }
          {this.state.uploadModal ? (
            <>
              <Modal
                open={this.state.uploadModal}
                onClose={this.closeUploadModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box
                  sx={styleModal}
                  style={{
                    width: "30%",
                    height: "200px",
                    border: "1px solid white",
                    textAlign: "center",
                  }}
                >
                  <input
                    style={{
                      display: "block",
                      margin: "auto",
                      marginRight: "5px",
                    }}
                    type="file"
                    ref={this.fileInputRef}
                    onChange={this.onFileChange}
                  />
                  {this.state.fileMsg ? (
                    <>
                      <div style={{ textAlign: "center" }}>
                        <span
                          style={{
                            color: "red",
                            fontSize: "10px",
                          }}
                        >
                          {this.state.fileMsg}
                        </span>
                      </div>
                    </>
                  ) : null}

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "rgb(97 110 120",
                      border: "1px ridge gray",
                      width: "40%",
                      boxShadow: "none",
                      height: "35px",
                      color: "white",
                      fontSize: "small",
                      marginTop: "20px",
                    }}
                    onClick={this.handleFileUpload}
                  >
                    Upload File
                  </Button>
                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.updatePriceListModal ? (
            <>
              <Modal
                open={this.state.updatePriceListModal}
                onClose={this.handleClosePriceListModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box
                  sx={styleModal}
                  style={{
                    width: "50%",
                    height: "500px",
                    overflowY: "scroll",
                    border: "1px solid white",
                  }}
                >
                  <Row>
                    <Col xs={6}>

                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          required
                          name="internalcode"
                          label="Internal Code"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.internalcode
                              ? this.state.internalcode
                              : ""
                          }
                        />
                      </FormControl>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          required
                          name="internaldescription"
                          label="Internal Description"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.internaldescription
                              ? this.state.internaldescription
                              : ""
                          }
                        />
                      </FormControl>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          type="number"
                          required
                          name="price"
                          label="Price"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.price ? this.state.price : this.state.price == 0 ? this.state.price : null
                          }
                        />
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          type="number"
                          required
                          name="discount"
                          label="Discount"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.discount ? this.state.discount : this.state.discount == 0 ? this.state.discount : null
                          }
                        />
                      </FormControl>
                    </Col>

                    <Col>
                      <FormControl
                        sx={{ mb: 3 }} style={{ width: "100%" }}
                      >
                        <InputLabel
                          id="service type"
                          style={{ fontSize: "small" }}
                        >
                          Service Type
                        </InputLabel>
                        <Select
                          required
                          fullWidth
                          labelId="service type"
                          name="servicetype"
                          label="Service Type"
                          value={this.state.servicetype ? this.state.servicetype : ""}
                          onChange={this.handleTextChange}
                          style={{ height: "45px" }}
                        >
                          <MenuItem
                            value="consultation"
                            style={{ fontSize: "small" }}
                          >
                            Consultation
                          </MenuItem>
                          <MenuItem
                            value="dental"
                            style={{ fontSize: "small" }}
                          >
                            Dental
                          </MenuItem>{" "}
                          <MenuItem
                            value="laboratory"
                            style={{ fontSize: "small" }}
                          >
                            Laboratory
                          </MenuItem>{" "}
                          <MenuItem
                            value="medication"
                            style={{ fontSize: "small" }}
                          >
                            Medication
                          </MenuItem>{" "}
                          <MenuItem
                            value="procedure"
                            style={{ fontSize: "small" }}
                          >
                            Procedure
                          </MenuItem>
                          <MenuItem
                            value="radiology"
                            style={{ fontSize: "small" }}
                          >
                            Radiology
                          </MenuItem>
                        </Select>
                      </FormControl>


                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          required
                          name="sbscode"
                          label="SBS Code"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.sbscode ? this.state.sbscode : ""
                          }
                        />
                      </FormControl>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          required
                          name="sbsdescription"
                          label="SBS Description"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.sbsdescription
                              ? this.state.sbsdescription
                              : ""
                          }
                        />
                      </FormControl>
                    </Col>

                  </Row>
                  <Row>
                    <div style={{ textAlign: "center" }}>
                      <FormControlLabel style={{ display: "block" }}
                        control={
                          <Checkbox
                            name="packagee"
                            checked={
                              this.state.packagee ? true : false
                            }
                            onChange={(e) => this.handleCheckBoxChange(e)}
                          />
                        }
                        label="Package"
                      />
                    </div>
                  </Row>
                  <div style={{ textAlign: "center" }}>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={(e) => this.updatePriceList(e)}
                      style={{
                        width: "30%",
                        marginTop: "10px",
                        backgroundColor: "rgb(97 110 120",
                        border: "1px solid rgb(97 110 120",
                        color: "white",
                      }}
                    >
                      Update
                    </Button>
                  </div>
                </Box>
              </Modal>
            </>
          ) : null}
        </div>
      </div>
    );
  }
}

export default priceListManagment;
